import { _ as _ts_decorate } from "@swc/helpers/_/_ts_decorate";
import { _ as _ts_metadata } from "@swc/helpers/_/_ts_metadata";
import { action, makeObservable, observable, runInAction } from "mobx";
import { BaseOptions } from "@devowl-wp/utils";
import { rmlOpts } from "../utils/rmlOpts.js";
class OptionStore extends BaseOptions {
    busySettings = false;
    // Implement "others" property in your Assets.php
    others;
    pureSlug;
    pureSlugCamelCased;
    rootStore;
    constructor(rootStore){
        super();
        this.rootStore = rootStore;
        this.pureSlug = BaseOptions.getPureSlug(process.env.slug);
        this.pureSlugCamelCased = BaseOptions.getPureSlug(process.env.slug, true);
        makeObservable(this);
        // PHP localizes as legacy `rmlOpts`, not `realMediaLibrary` (see Assets.php).
        runInAction(()=>{
            const { others, ...rest } = rmlOpts;
            Object.assign(this, rest);
            this.others = observable(others);
        });
    }
    setShowLicenseFormImmediate(state) {
        this.others.showLicenseFormImmediate = state;
    }
}
_ts_decorate([
    observable
], OptionStore.prototype, "busySettings", void 0);
_ts_decorate([
    observable,
    _ts_metadata("design:type", typeof RmlOptsOthers === "undefined" ? Object : RmlOptsOthers)
], OptionStore.prototype, "others", void 0);
_ts_decorate([
    action,
    _ts_metadata("design:type", Function),
    _ts_metadata("design:paramtypes", [
        Boolean
    ]),
    _ts_metadata("design:returntype", void 0)
], OptionStore.prototype, "setShowLicenseFormImmediate", null);
export { OptionStore };
